const translation = {
  // Nav
  nav_home: "Accueil",
  nav_shop: "Boutique",
  nav_custom: "Boîte Cadeau Personnalisée",
  nav_occasions: "Occasions",
  nav_about: "À Propos",
  nav_contact: "Contact",
  nav_blog: "Blog",
  nav_cart: "Panier",
  nav_tagline: "Boutique Cadeaux Premium · Douala, Cameroun",

  // Hero
  hero_headline: "Des Cadeaux Qui Créent",
  hero_headline2: "Des Souvenirs Inoubliables",
  hero_subtitle: "Fleurs, bougies, livres, gourmandises et boîtes cadeaux personnalisées pour chaque occasion spéciale.",
  hero_btn_shop: "Acheter Maintenant",
  hero_btn_custom: "Personnaliser une Boîte",
  hero_btn_contact: "Nous Contacter",

  // Categories
  cat_title: "Nos Collections",
  cat_subtitle: "Des cadeaux soigneusement sélectionnés pour chaque moment",
  cat_flowers: "Fleurs Fraîches",
  cat_candles: "Bougies Parfumées",
  cat_books: "Livres & Journaux",
  cat_jellies: "Gelées Maison",
  cat_spices: "Épices Gourmandes",
  cat_giftboxes: "Boîtes Cadeaux",
  cat_corporate: "Cadeaux d'Entreprise",
  cat_seasonal: "Cadeaux Saisonniers",
  cat_explore: "Explorer",

  // Why Choose
  why_title: "Pourquoi Choisir Creative Hub",
  why_subtitle: "Nous créons des expériences, pas seulement des cadeaux",
  why_quality: "Qualité Premium",
  why_quality_desc: "Chaque article est sélectionné à la main pour sa beauté, sa qualité et son impact émotionnel.",
  why_packaging: "Emballage Élégant",
  why_packaging_desc: "Un emballage luxueux qui rend chaque cadeau inoubliable.",
  why_personalized: "Cadeaux Personnalisés",
  why_personalized_desc: "Messages, noms et sélections personnalisés rien que pour vous.",
  why_delivery: "Livraison Rapide",
  why_delivery_desc: "Livraison fiable et ponctuelle à Douala et dans tout le Cameroun.",
  why_corporate: "Solutions Entreprises",
  why_corporate_desc: "Commandes en gros et cadeaux de marque pour les entreprises et événements.",

  // Bestsellers
  best_title: "Meilleures Ventes",
  best_subtitle: "Nos cadeaux les plus appréciés, choisis par nos clients",
  best_add: "Ajouter au Panier",
  best_whatsapp: "Commander via WhatsApp",
  best_wishlist: "Ajouter aux Favoris",

  // Custom Box
  custom_title: "Créez Votre Boîte Cadeau Idéale",
  custom_subtitle: "Créez un panier personnalisé unique",
  custom_step1: "Choisir les Produits",
  custom_step2: "Sélectionner l'Emballage",
  custom_step3: "Ajouter un Message",
  custom_step4: "Demander un Devis",
  custom_cta: "Commencer la Personnalisation",

  // Testimonials
  testi_title: "Ce Que Disent Nos Clients",
  testi_subtitle: "De vraies histoires de personnes qui ont offert avec amour",

  // CTA
  cta_title: "Rendez Chaque Occasion Spéciale",
  cta_subtitle: "avec Creative Hub",
  cta_desc: "Des anniversaires aux événements d'entreprise, nous avons le cadeau parfait pour chaque moment.",
  cta_btn: "Acheter Maintenant",
  cta_whatsapp: "Discuter sur WhatsApp",

  // Shop
  shop_title: "Notre Boutique Cadeaux",
  shop_subtitle: "Découvrez notre collection complète de cadeaux premium",
  shop_filter_all: "Tous",
  shop_search: "Rechercher des cadeaux...",
  shop_sort: "Trier par",
  shop_sort_popular: "Plus Populaires",
  shop_sort_price_asc: "Prix: Croissant",
  shop_sort_price_desc: "Prix: Décroissant",
  shop_sort_newest: "Nouveautés",
  shop_add_cart: "Ajouter au Panier",
  shop_whatsapp: "Commander WhatsApp",
  shop_no_results: "Aucun produit trouvé",

  // Custom Gift Box Page
  cgb_title: "Boîte Cadeau Personnalisée",
  cgb_subtitle: "Concevez une expérience cadeau personnalisée",
  cgb_products_title: "1. Choisissez Vos Produits",
  cgb_packaging_title: "2. Sélectionnez l'Emballage",
  cgb_message_title: "3. Ajoutez un Message Personnel",
  cgb_message_placeholder: "Écrivez votre message sincère ici...",
  cgb_name_label: "Votre Nom",
  cgb_email_label: "Votre Email",
  cgb_phone_label: "Téléphone / WhatsApp",
  cgb_submit: "Demander un Devis",
  cgb_whatsapp: "Commander via WhatsApp",
  cgb_selected: "Sélectionné",
  cgb_packaging_classic: "Élégance Classique",
  cgb_packaging_luxury: "Or Luxueux",
  cgb_packaging_romantic: "Rose Romantique",
  cgb_packaging_corporate: "Premium Entreprise",

  // Occasions
  occ_title: "Cadeaux pour Chaque Occasion",
  occ_subtitle: "Trouvez le cadeau parfait pour chaque moment spécial",
  occ_birthdays: "Anniversaires",
  occ_weddings: "Mariages",
  occ_anniversaries: "Anniversaires de Couple",
  occ_valentine: "Saint-Valentin",
  occ_mothers: "Fête des Mères",
  occ_corporate: "Événements d'Entreprise",
  occ_christmas: "Noël",
  occ_shop_now: "Voir cette Collection",

  // About
  about_title: "À Propos de Creative Hub",
  about_subtitle: "Une boutique cadeaux premium au cœur de Douala",
  about_story_title: "Notre Histoire",
  about_story: "Creative Hub est né d'une passion pour les cadeaux significatifs. Situé à Akwa, Douala, nous croyons que chaque cadeau doit raconter une histoire — d'amour, d'appréciation et de célébration. Nous sélectionnons à la main chaque produit de notre collection pour garantir qu'il répond à nos standards de beauté, de qualité et de résonance émotionnelle.",
  about_mission_title: "Notre Mission",
  about_mission: "Aider chaque client à exprimer ses émotions les plus profondes à travers des cadeaux soigneusement sélectionnés et personnalisés qui créent des souvenirs durables.",
  about_values_title: "Nos Valeurs",
  about_val1: "Élégance",
  about_val2: "Authenticité",
  about_val3: "Créativité",
  about_val4: "Soin",
  about_team_title: "Notre Équipe",

  // Contact
  contact_title: "Contactez-Nous",
  contact_subtitle: "Nous serions ravis de vous entendre",
  contact_name: "Votre Nom",
  contact_email: "Votre Email",
  contact_phone: "Téléphone / WhatsApp",
  contact_subject: "Sujet",
  contact_message: "Votre Message",
  contact_send: "Envoyer le Message",
  contact_whatsapp: "Discuter sur WhatsApp",
  contact_email_us: "Nous Écrire",
  contact_location: "Notre Adresse",
  contact_hours: "Heures d'Ouverture",
  contact_hours_val: "Lun – Sam: 8h00 – 19h00",
  contact_address: "1401 Melrose Place, Akwa, Douala, Cameroun",
  contact_phone_val: "+237 678 012 159",
  contact_email_val: "creativehub@gmail.com",

  // Blog
  blog_title: "Idées Cadeaux & Inspiration",
  blog_subtitle: "Conseils, tendances et histoires du monde des cadeaux",
  blog_read_more: "Lire la Suite",
  blog_min_read: "min de lecture",

  // Footer
  footer_tagline: "Boutique cadeaux premium à Douala, Cameroun. Créer des souvenirs un cadeau à la fois.",
  footer_links: "Liens Rapides",
  footer_contact: "Contact",
  footer_newsletter: "Newsletter",
  footer_newsletter_desc: "Abonnez-vous pour des idées cadeaux et des offres exclusives.",
  footer_newsletter_placeholder: "Votre adresse email",
  footer_newsletter_btn: "S'abonner",
  footer_rights: "© 2026 Creative Hub. Tous droits réservés.",
  footer_privacy: "Politique de Confidentialité",
  footer_terms: "Conditions d'Utilisation",

  // Cart
  cart_title: "Votre Panier",
  cart_empty: "Votre panier est vide",
  cart_total: "Total",
  cart_checkout: "Commander via WhatsApp",
  cart_remove: "Supprimer",
  cart_continue: "Continuer les Achats",

  // Common
  common_xaf: "XAF",
  common_loading: "Chargement...",
  common_close: "Fermer",
  common_back: "Retour",
  common_view_all: "Voir Tout",
  common_new: "Nouveau",
  common_sale: "Promo",
  common_popular: "Populaire",
};

export default translation;